<template>
    <div class="banner-add">
        <bread-crumb :bread-list="breadList" />
        <div class="add-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">新增视频</span>
            </div>
            <el-form
                :model="bannerForm"
                ref="bannerForm"
                v-loading="loading"
                label-width="104px"
                class="banner-form"
            >
                <el-form-item
                    label="名称"
                    prop="bannerTitle"
                    :rules="[
                        {
                            required: true,
                            message: '请输入上传名称',
                            trigger: 'change'
                        }
                    ]"
                >
                    <el-input
                        v-model.trim="bannerForm.bannerTitle"
                        class="from-input"
                        placeholder="请输入上传名称"
                        maxlength="50"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="URL"
                    prop="url"
                    :rules="[
                        {
                            required: true,
                            message: '请输入URL',
                            trigger: 'change'
                        }
                    ]"
                >
                    <el-input
                        v-model.trim="bannerForm.url"
                        class="from-input"
                        placeholder="请输入URL"
                        maxlength="200"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="封面图"
                    prop="coverPicture"
                    :rules="[
                        {
                            required: true,
                            message: '请上传封面图',
                            trigger: 'change'
                        }
                    ]"
                >
                    <div v-if="bannerForm.coverPicture" class="cover-content">
                        <el-image
                            fit="fill"
                            class="cover-picture"
                            :src="
                                '/ms-hoc-video/v1/image/download?fileName=' +
                                    bannerForm.coverPicture
                            "
                        >
                        </el-image>
                        <i
                            class="iconfont icon-jinggaochacha"
                            @click="handleRemove"
                        ></i>
                    </div>

                    <el-upload
                        v-else
                        v-loading="pictureLoading"
                        class="picture-uploader"
                        :action="uploadAction"
                        :show-file-list="false"
                        accept=".jpg, .png,.jpeg"
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload"
                    >
                        <div class="picture-content">
                            <i class="iconfont icon-camera"></i>
                            <div class="picture_text">
                                上传封面图
                            </div>
                        </div>
                    </el-upload>
                    <h1 class="uploader-tips">
                        建议图片小于1M，图片格式为png、jpg、jpeg，图片尺寸建议698px*280px
                    </h1>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        class="submit-btn"
                        @click="submitForm('bannerForm')"
                        >提交</el-button
                    >
                    <el-button @click="handleCandle" class="cancle-btn"
                        >取消</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postAddBanner } from "@/api/banner";
import { checkFileSize } from "@/utils/checkFiles";

export default {
    name: "addVideoManagement",
    data() {
        return {
            breadList: [
                { label: "咨询专区" },
                { label: "视频管理", path: "/counsel/videoManagement" },
                { label: "新增视频" }
            ],
            bannerForm: {
                bannerTitle: "",
                url: "",
                coverPicture: ""
            },
            loading: false,
            pictureLoading: false
        };
    },
    computed: {
        ...mapGetters(["userInfo"]),
        uploadAction() {
            return `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=BANNER`;
        }
    },
    methods: {
        handleCandle() {
            this.$router.push("/counsel/videoManagement");
        },
        beforeUpload(file) {
            // this.pictureLoading = true
            // return true
            return checkFileSize(
                file,
                this,
                1,
                "建议图片小于1M，图片格式为png、jpg、jpeg，图片尺寸建议698px*280px"
            );
        },
        handleSuccess(res, file) {
            let data = res.results;
            if (data && data.length > 0) {
                this.bannerForm.coverPicture = data[0].originPictureId;
                this.$refs["bannerForm"].clearValidate();
            } else {
                this.$message.error("上传出错，请检查上传图片！");
            }
            this.pictureLoading = false;
        },
        handleRemove() {
            this.bannerForm.coverPicture = "";
            this.pictureLoading = false;
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.postBanner();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        async postBanner() {
            let params = {
                bannerTitle: this.bannerForm.bannerTitle,
                url: this.bannerForm.url,
                coverPicture: this.bannerForm.coverPicture,
                uploader: this.userInfo.accountName,
                isAdvice: true
            };
            this.loading = true;
            const { results } = await postAddBanner(params);

            if (results === "Banner name cannot be repeated") {
                this.$message({
                    message: "Banner名称重复，请重新填写！",
                    type: "warning"
                });
            } else {
                this.$message({
                    message: "新增banner成功",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                this.$router.push("/counsel/videoManagement");
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="scss">
.banner-add {
    height: 100%;
    .add-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .banner-form {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .cover-content {
                    position: relative;
                    .cover-picture {
                        width: 339px;
                        height: 130px;
                    }
                    .icon-jinggaochacha {
                        cursor: pointer;
                        font-size: 16px;
                        color: #ec6a69;
                        position: absolute;
                        top: -15px;
                        left: 330px;
                    }
                }

                .picture-uploader {
                    width: 327px;
                    height: 130px;
                    background: #d8d8d8;
                    text-align: center;
                    .picture-content {
                        margin-top: 40px;
                        .icon-camera {
                            font-size: 24px;
                            color: #fff;
                        }
                        .picture_text {
                            margin-top: 2px;
                            font-family: PingFang-SC-Medium;
                            font-size: 14px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 14px;
                        }
                    }
                }
                .uploader-tips {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                    font-weight: normal;
                    margin-top: 10px;
                }
                .form-datetime {
                    width: 320px;
                    .el-input__inner {
                        height: 32px;
                    }
                    .el-input__prefix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }
                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
